export const INSTALL_FONTS = 'INSTALL_FONTS';
export const AUTO_GROW_LAYOUT_REQUEST = 'AUTO_GROW_LAYOUT_REQUEST';
